// 全站唯一的接口前缀。本地开发走 /api 代理，正式打包直连系统接口。
export const apiBaseURL = process.env.NODE_ENV === 'production'
  ? 'https://system.eltmax.cn'
  : '/api'
